import update from 'immutability-helper';
import * as types from './types';

export const initialState = {
  initializing:  true,
};

const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[types.DONE] = (state) => update(state, {
  initializing: {
    $set: false,
  },
});

export default (state = initialState, action) => (
  switchMap[action.type]
    ? switchMap[action.type](state, action)
    : state
);
